import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatCommonModule } from '@angular/material/core';
import { MatGridListModule } from '@angular/material/grid-list';

import { SignaturePadModule } from 'angular2-signaturepad';

import { PepperiModule } from '@pepperi/lib';
import { PepperiDialogModule } from '@pepperi/lib/dialog';

import { PepperiAddressModule } from '@pepperi/lib/address';
import { PepperiAttachmentModule } from '@pepperi/lib/attachment';
import { PepperiCheckboxModule } from '@pepperi/lib/checkbox';
import { PepperiDateModule } from '@pepperi/lib/date';
import { PepperiImageModule } from '@pepperi/lib/image';
import { PepperiImagesFilmstripModule } from '@pepperi/lib/images-filmstrip';
import { PepperiInternalButtonModule } from '@pepperi/lib/internal-button';
import { PepperiMenuModule } from '@pepperi/lib/menu';
import { PepperiQuantitySelectorModule } from '@pepperi/lib/quantity-selector';
import { PepperiRichHtmlTextareaModule } from '@pepperi/lib/rich-html-textarea';
import { PepperiSelectModule } from '@pepperi/lib/select';
import { PepperiSeparatorModule } from '@pepperi/lib/separator';
import { PepperiSignatureModule } from '@pepperi/lib/signature';
import { PepperiTextareaModule } from '@pepperi/lib/textarea';
import { PepperiTextboxModule } from '@pepperi/lib/textbox';
const pepperiComponentsModules = [
    PepperiAddressModule,
    PepperiAttachmentModule,
    PepperiCheckboxModule,
    PepperiDateModule,
    PepperiImageModule,
    PepperiImagesFilmstripModule,
    PepperiInternalButtonModule,
    PepperiMenuModule,
    PepperiQuantitySelectorModule,
    PepperiRichHtmlTextareaModule,
    PepperiSelectModule,
    PepperiSeparatorModule,
    PepperiSignatureModule,
    PepperiTextareaModule,
    PepperiTextboxModule,
];


import { PepperiFormComponent } from './form.component';
import { PepperiFieldGeneratorComponent } from './field-generator.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        // Material modules,
        MatCommonModule,
        MatGridListModule,
        // External modules
        SignaturePadModule,
        // Pepperi modules
        PepperiModule,
        PepperiDialogModule,
        pepperiComponentsModules,
    ],
    exports: [PepperiFormComponent],
    declarations: [
        PepperiFormComponent,
        PepperiFieldGeneratorComponent
    ],
})
export class PepperiFormModule {
}
